import { Component } from "react";

import "./style.scss";

class Radio extends Component {

    onChange=(e)=>{
        if(this.props.onChange) this.props.onChange(e);
    }

    render() {
        return (
            <label className="custom-radio">{this.props.label}
                <input ref={el => (this.input = el)} type="radio" checked={this.props.checked} name={this.props.name || "radio"} onChange={this.onChange} />
                <span className="checkmark"></span>
            </label>
        )
    }
}

export default Radio;